import { render, staticRenderFns } from "./Sic.vue?vue&type=template&id=728eb1e1&scoped=true"
import script from "./Sic.vue?vue&type=script&lang=js"
export * from "./Sic.vue?vue&type=script&lang=js"
import style0 from "./Sic.vue?vue&type=style&index=0&id=728eb1e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728eb1e1",
  null
  
)

export default component.exports